import { render, staticRenderFns } from "./register-check.component.vue?vue&type=template&id=2593091c&scoped=true"
import script from "./register-check.component.vue?vue&type=script&lang=js"
export * from "./register-check.component.vue?vue&type=script&lang=js"
import style0 from "./register-check.component.vue?vue&type=style&index=0&id=2593091c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2593091c",
  null
  
)

export default component.exports